import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import WebSocketNotification from './webSocketComponent';
import { setNotificationData } from '../toastNotification/toastNotificationSlice';
import { getAllOrders } from '../../pages/SwapsTek/DashboardActions';

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      setNotificationData,
      getAllOrders,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketNotification);
